<div class="col px-lg-5 px-2">
	<app-nav-prestation></app-nav-prestation>

	<div *ngIf="prestation" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ PrestationTypeString[prestation.typePrestation] }} ({{prestation.beneficiaire?.firstName + ' ' +  prestation.beneficiaire?.lastName + ' - ' + prestation.numeroCommande}})</span
					>
				</div>

				<div class="">
					<a
						*ngIf="isDeletable"
						(click)="openConfirmDeleteModal(deletePrestation)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<app-prestation-form
				*ngIf="!isFormReadOnly"
				[prestation]="prestation"
				[isAddForm]="false"
				[form]="prestationDetailForm"
				[isValidateButtonClicked]="isValidateButtonClicked"
				[isLoadingBeneficiaires]="isLoadingBeneficiaires"
				(sendForm)="onSubmit()"
			>
			</app-prestation-form>
            <div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col-6">
						<label
							for="inputPrestationStatut"
							class="form-label theme-main-color fw-bold"
							>Statut</label
						>
						<span class="form-control-plaintext">{{
							PrestationStatutStringEnum[prestation.statut]
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-6">
						<label
							for="inputPrestationType"
							class="form-label theme-main-color fw-bold"
							>Type de prestation</label
						>
						<span class="form-control-plaintext">{{
							PrestationTypeStringEnum[prestation.typePrestation]
						}}</span>
					</div>
					<div class="col-6 col-lg" *ngIf="this.isQDSelected">
						<label for="dateDepot" class="form-label fw-bold"
							>Date de dépôt</label
						>
						<span class="form-control-plaintext">{{
							prestation.dateDepot | date: 'dd/MM/yyyy'
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="dateDebut" class="form-label fw-bold"
							>Date de démarrage</label
						>
						<span class="form-control-plaintext">{{
							prestation.dateDebut | date: 'dd/MM/yyyy'
						}}</span>
					</div>
					<div class="col-12 col-lg">
						<label for="dateLimite" class="form-label fw-bold"
							>Date de limite d'exécution</label
						>
						<span class="form-control-plaintext">{{
							prestation.dateLimite | date: 'dd/MM/yyyy'
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="periode" class="form-label fw-bold"
							>Période d'exécution</label
						>
						<span class="form-control-plaintext">{{
							prestation.periode
						}} mois</span>
					</div>
					<div class="col-12 col-lg">
						<label for="duree" class="form-label fw-bold"
							>Durée</label
						>
						<span class="form-control-plaintext">{{
							prestation.duree
						}} heures</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="dureePrevisionnelle" class="form-label fw-bold"
							>Durée prévisionnelle</label
						>
						<span class="form-control-plaintext">{{
							prestation.dureePrevisionnelle
						}} heures</span>
					</div>
				</div>
                <div class="row my-4">
					<div class="col-12 col-lg">
						<label for="beneficiaire" class="form-label fw-bold"
							>Bénéficiaire</label
						>
						<span class="form-control-plaintext">{{
							prestation.beneficiaire?.firstName + ' ' +  prestation.beneficiaire?.lastName
						}}</span>
					</div>
				</div>

			</div>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm(true)"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!prestationDetailForm.valid || isValidateButtonClicked.value || isLoadingBeneficiaires.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<div *ngIf="prestation" class="my-4">
		<div class="row my-5">
			<span class="theme-main-color fw-bold fs-5"
				>Fichiers</span
			>
		</div>
		<div class="row mb-5 d-flex justify-content-start">
			<button class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
				(click)="openModalFichierAjout()"
			>
				<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
			</button>
		</div>
		<div class="my-2">
			<!-- <div
				*ngFor="
					let suivi of suiviPrestationList
						| sortBySuiviPrestationDate : sortOrder
						| paginate : { itemsPerPage: 5, currentPage: currentPage }
						| orderBy : 'suivi.dateEntretien' : sortOrder
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailFormation(suivi)"
			> -->

			<div
			*ngFor="
					let prestationFichier of prestationFichierList
						| paginate : { id: 'paginationFichier', itemsPerPage: 5, currentPage: currentPageFichier }
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				
			>
				<div class="col-lg-3 col-10">
					<span class="align-middle"
						>Date : {{ prestationFichier.date | date : 'dd/MM/YYYY HH:mm' }}
					</span>
				</div>
				<div class="col-lg-3 col" *ngIf="true">
					<span class="align-middle">Type de document : {{
						prestationFichier.typeDocument?.name
					}}</span>
				</div>
				<div class="col-lg-4 col" *ngIf="true">
					<span class="align-middle">{{
						prestationFichier.filename
					}}</span>
				</div>
				<div class="col-lg-2 col" *ngIf="true">
					<button style="padding: unset;"
					class="col-2 btn theme-white-button mx-3"
					(click)="download(prestationFichier)"
					>
					<i class="bi bi-download" aria-hidden="true"></i>
					</button>
					<button
					class="col-2 btn theme-red-button" style="padding: unset;"
					(click)="deletePrestationFichier(prestationFichier.id)"
					>
					<i class="bi bi-trash-fill" aria-hidden="true"></i>
				</button>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls id="paginationFichier"
					class="d-flex justify-content-center"
					(pageChange)="currentPageFichier = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div>

	<div *ngIf="!isSPSelected && prestation" class="my-4">
		<div class="row my-5">
			<span class="theme-main-color fw-bold fs-5"
				>Suivi des activités</span
			>
		</div>
		<div class="row mb-5 d-flex justify-content-start">
			<button class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
				(click)="openModalActivitePrestationAjout()"
			>
				<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
			</button>
			<!-- <div class="alert alert-danger alert-dismissible fade show my-2 mx-2"
			profile="alert"
				>
					Vous ne pouvez pas à une prestation qui n'est pas en cours
			</div> -->
		</div>
		<div class="my-2">
			<!-- <div
				*ngFor="
					let suivi of suiviPrestationList
						| sortBySuiviPrestationDate : sortOrder
						| paginate : { itemsPerPage: 5, currentPage: currentPage }
						| orderBy : 'suivi.dateEntretien' : sortOrder
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailFormation(suivi)"
			> -->

			<div
			*ngFor="
					let activite of activitePrestationList
						| orderBy : 'dateEntretien' : sortOrderActivite
						| paginate : { id: 'paginationActivite', itemsPerPage: 10, currentPage: currentPageActivite }
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="disableButtonAddSuivi ? null : openModalDetailActivite(activite)"
			>
				<!-- <div class="col-lg-1 col-10">
					<span class="align-middle" *ngIf="activite.cotraitant">
						Soutien cotraitant
					</span>
				</div> -->
				<div class="col-lg-2 col-10">
					<span class="align-middle">
						{{ activite.modaliteReunion?.name }}
					</span>
				</div>
				<div class="col-lg-2 col-10">
					<span class="align-middle"
						>Date d'entretien : {{ activite.dateEntretien | date : 'dd/MM/yyyy' }}
					</span>
				</div>
				<div class="col-lg-2 col" >
					<span class="align-middle">{{
						activite.tache?.name
					}}</span>
				</div>
				<div class="col-lg-2 col">
					<span class="align-middle">Charge de travail : {{
						activite.chargeTravail
					}}h</span>
				</div>
				<div class="col-lg-2 col">
					<span class="align-middle" *ngIf="activite.bonCommandeReference?.bonCommande">{{
						activite.bonCommandeReference?.bonCommande?.marche + ' ' + activite.bonCommandeReference?.bonCommande?.commande
					}}</span>
				</div>
				<div class="col-lg-2 col" *ngIf="true">
					<span class="align-middle">Intervenant : {{
						 activite.intervenant?.firstName + ' ' + activite.intervenant?.lastName
					}}</span>
					<i
						class="bi bi-caret-right-fill mb-1 align-middle"
						aria-hidden="true"
					></i>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls id="paginationActivite"
					class="d-flex justify-content-center"
					(pageChange)="currentPageActivite = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div>

	<div *ngIf="prestation && showRestitution" class="my-4">
		<div class="row my-5">
			<span class="theme-main-color fw-bold fs-5"
				>Restitutions</span
			>
		</div>
		<div class="row mb-5 d-flex justify-content-start">
			<button class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
				(click)="openModalRestitutionPrestationAjout()"
			>
				<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
			</button>
			<!-- <div class="alert alert-danger alert-dismissible fade show my-2 mx-2"
			profile="alert"
			*ngIf="disableButtonAddSuivi"
				>
					Vous ne pouvez pas à une prestation qui n'est pas en cours
			</div> -->
		</div>
		<div class="my-2">
			<!-- <div
				*ngFor="
					let suivi of suiviPrestationList
						| sortBySuiviPrestationDate : sortOrder
						| paginate : { itemsPerPage: 5, currentPage: currentPage }
						| orderBy : 'suivi.dateEntretien' : sortOrder
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailFormation(suivi)"
			> -->

			<div
			*ngFor="
					let restitution of restitutionPrestationList
						| paginate : { id: 'paginationRestitution', itemsPerPage: 5, currentPage: currentPageRestitution }
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailRestitution(restitution)"
			>
				<div class="col-lg-5 col-10">
					<span class="align-middle">
						{{ ResitutionTypeEnumString[restitution.type] }}
					</span>
					<i
						class="bi bi-caret-right-fill mb-1 align-middle"
						aria-hidden="true"
					></i>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls id="paginationRestitution"
					class="d-flex justify-content-center"
					(pageChange)="currentPageRestitution = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div>

	<!-- <div *ngIf="prestation" class="my-4">
		<div class="row my-5">
			<span class="theme-main-color fw-bold fs-5"
				>Suivi</span
			>
		</div>
		<div class="row mb-5 d-flex justify-content-start">
			<button class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
				(click)="openModalSuiviPrestationAjout()"
			>
				<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
			</button>
		</div>
		<div class="my-2">
			 <div
				*ngFor="
					let suivi of suiviPrestationList
						| sortBySuiviPrestationDate : sortOrder
						| paginate : { itemsPerPage: 5, currentPage: currentPage }
						| orderBy : 'suivi.dateEntretien' : sortOrder
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailFormation(suivi)"
			> 

			<div
			*ngFor="
					let suivi of suiviPrestationList
						| paginate : { itemsPerPage: 5, currentPage: currentPageSuivi }
						| orderBy : 'suivi.dateEntretien' : sortOrderSuivi
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailSuivi(suivi)"
			>
				<div class="col-lg-3 col-10">
					<span class="align-middle"
						>Date d'entretien : {{ suivi.dateEntretien | date : 'dd/MM/YYYY HH:mm' }}
					</span>
				</div>
				<div class="col-lg-2 col-10">
					<span class="align-middle">
						{{ suivi.modaliteReunion?.name }}
					</span>
				</div>
				<div class="col-lg-3 col" *ngIf="true">
					<span class="align-middle">{{
						suivi.typeEntretien?.name
					}}</span>
				</div>
				<div class="col-lg-4 col-10">
					<span class="align-middle"
						>Date du prochain entretien : {{ suivi.dateProchainEntretien | date : 'dd/MM/YYYY HH:mm' }}
					</span>
					<i
						class="bi bi-caret-right-fill mb-1 align-middle"
						aria-hidden="true"
					></i>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls
					class="d-flex justify-content-center"
					(pageChange)="currentPage = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div> -->

	<ng-template #deletePrestation>
		<div class="modal-header text-center">
			<h4>Suppression</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			<a class="btn theme-red-button ms-3" (click)="delete(prestation)"
				>Supprimer</a
			>
		</div>
	</ng-template>

	<!-- <ng-template #deletePrestationFichier>
		<div class="modal-header text-center">
			<h4>Suppression</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteFichierModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteFichierModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			 <a class="btn theme-red-button ms-3" (click)="deletePrestationFichier()"
				>Supprimer</a
			> 
		</div>
	</ng-template> -->
</div>
